import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  getData,
  getDataWithComp,
  getViewAp,
  insertData,
  updateData,
} from "../../../../utils/SamuiUtils";
import ApModal from "../../../components/Modal/ApModal";
import ArModal from "../../../components/Modal/ArModal";
import CompModal from "../../../components/Modal/CompModal";
import BankModal from "../../../components/Modal/BankModal";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  masterList
}) => {
  const [initialFormData, setInitialFormData] = useState({});
  
  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Prevent shortcuts when typing in input fields
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT') {
        return;
      }
      
      // ESC key - Cancel/Back
      if (event.key === 'Escape') {
        event.preventDefault();
        if (window.confirm('ต้องการยกเลิกการทำงานหรือไม่?')) {
          window.location.href = "/tbsetbank";
        }
      }
      
      // F10 key - Save
      if (event.key === 'F10') {
        event.preventDefault();
        if (mode === 'I') return;
        handleConfirmUpdate();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  
  const [apDataList, setApDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [compDataList, setCompDataList] = useState([]);
  const [bankDataList, setBankDataList] = useState([]);
  const [selectName, setSelectName] = useState("");
  const [selectBankName, setSelectBankName] = useState("");
  const [showBankModal, setShowBankModal] = useState(false);
  const handleShowBank = () => setShowBankModal(true);
  const handleCloseBank = () => setShowBankModal(false);
  const onRowSelectBank = (bank) => {
    setSelectBankName(bank.B_Name_TH);
    setFormData({
      ...formData,
      Bank_Master_Id: bank.Bank_Master_Id
    });
    setInitialFormData({
      ...initialFormData,
      Bank_Master_Id: bank.Bank_Master_Id
    });
    handleCloseBank();
  };

  useEffect(() => {
    initialize();
  }, []);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
    }));
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        Bank_Name_TH: "",
        Bank_Name_EN: "",
        Bank_Status: "Y",
        Bank_Account: "",
        Bank_Type: "SA",
        Comp_Id: localStorage.getItem("company"),
        APAR_Type: "AP",
        APAR_Id: "",
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        Bank_Id: selectedData.Bank_Id,
        Bank_Name_TH: selectedData.Bank_Name_TH,
        Bank_Name_EN: selectedData.Bank_Name_EN,
        Bank_Status: selectedData.Bank_Status,
        Bank_Account: selectedData.Bank_Account,
        Bank_Type: selectedData.Bank_Type,
        Comp_Id: selectedData.Comp_Id,
        APAR_Type: selectedData.APAR_Type,
        APAR_Id: selectedData.APAR_Id,
        Bank_Master_Id: selectedData.Bank_Master_Id
      };

      setSelectBankName(selectedData.B_Name_TH);
      setSelectName(selectedData.CCode + " " + selectedData.NName);

      setFormData(initialData);
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const initialize = async () => {
    try {
      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        setApDataList(apDataList);
      }

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      const compDataList = await getData(
        "Tb_Set_Company",
        "1 = 1 ORDER BY Comp_Id ASC"
      );
      if (compDataList && compDataList.length > 0) {
        setCompDataList(compDataList);
      }

      const bankDataList = await getData(
        "Tb_Set_Bank_Master",
        "1 = 1 ORDER BY Bank_Master_Id ASC"
      );
      if (bankDataList && bankDataList.length > 0) {
        setBankDataList(bankDataList);
      }

    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // เมื่อเปลี่ยนกลุ่มผู้ใช้ เคลียร์ค่า
    if (name === "APAR_Type") {
      setSelectName("");
      setFormData({
        ...formData,
        [name]: value,
        APAR_Id: "", // ล้างค่า ID เดิม
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleInsertBank = async () => {
    try {
      const { Bank_Id, ...dataToInsert } = formData;
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      const res = await insertData("Tb_Set_Bank", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error inserting bank:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };
  const formatValues = (data) => {
    const { Bank_Id, ...rest } = data;
    return rest;
  };

  const handleUpdateBank = async () => {
    try {
      const where = { Bank_Id: formData.Bank_Id };
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_Bank", values, where);
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize(selectedData?.Bank_Id);
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData("Tb_Set_Bank", `WHERE Bank_Id = ${selectedData.Bank_Id}`);
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  // ฟังก์ชันสำหรับรีเซ็ตฟอร์ม
  const handleReset = () => {
    if (mode === "I") {
      // Clear all form fields for Insert mode
      const clearedData = {
        Bank_Name_TH: "",
        Bank_Name_EN: "",
        Bank_Status: "Y",
        Bank_Account: "",
        Bank_Type: "SA",
        Comp_Id: localStorage.getItem("company"),
        APAR_Type: "AP",
        APAR_Id: "",
        Bank_Master_Id: ""
      };
      setFormData(clearedData);
      setSelectName("");
      setSelectBankName("");
    } else if (mode === "U") {
      // Reset formData to initial selectedData for Update mode
      if (selectedData) {
        const initialData = {
          Bank_Id: selectedData.Bank_Id,
          Bank_Name_TH: selectedData.Bank_Name_TH,
          Bank_Name_EN: selectedData.Bank_Name_EN,
          Bank_Status: selectedData.Bank_Status,
          Bank_Account: selectedData.Bank_Account,
          Bank_Type: selectedData.Bank_Type,
          Comp_Id: selectedData.Comp_Id,
          APAR_Type: selectedData.APAR_Type,
          APAR_Id: selectedData.APAR_Id,
          Bank_Master_Id: selectedData.Bank_Master_Id
        };
        setFormData(initialData);
        setSelectName(selectedData.CCode + " " + selectedData.NName || "");
        setSelectBankName(selectedData.B_Name_TH || "");
      }
    }
  };

  const handleConfirmUpdate = () => {
    getAlert("C_DIALOG", "ยืนยันการแก้ไขข้อมูล", async (isConfirm) => {
      if (isConfirm) {
        await handleUpdateBank();
      }
    });
  };

  const handleSubmit = async (e) => {
    if (!formData.Bank_Account) {
      getAlert("WARNING", "กรุณากรอกเลขบัญชีธนาคาร");
      return;
    }
    if (!formData.Bank_Master_Id && !formData.APAR_Id) {
      getAlert("WARNING", "กรุณากรอกชื่อธนาคาร หรือ เลือกเจ้าหนี้/ลูกหนี้/บริษัท อย่างใดอย่างหนึ่ง");
      return;
    }
    try {
      const isDuplicateAccount = masterList.some(item => item.Bank_Account === formData.Bank_Account);
      if (isDuplicateAccount) {
        getAlert("WARNING", "เลขบัญชีธนาคารนี้มีอยู่ในระบบแล้ว");
        return;
      }

      if (mode === "I") {
        await handleInsertBank();
      } else if (mode === "U") {
        await handleUpdateBank();
      }
      setFormData({
        Bank_Master_Id: "",
        Bank_Name_TH: "",
        Bank_Name_EN: "",
        Bank_Status: "Y",
        Bank_Account: "",
        Bank_Type: "",
        Comp_Id: localStorage.getItem("company"),
        APAR_Type: "",
        APAR_Id: "",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  // SET AP
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const onRowSelect = (dataSelected) => {
    try {
      let aparId = '';
      if (formData.APAR_Type === 'AP') {
        aparId = dataSelected.AP_Id;
        setSelectName(dataSelected.AP_Code + " " + dataSelected.AP_Name);
      } else if (formData.APAR_Type === 'AR') {
        aparId = dataSelected.AR_Id;
        setSelectName(dataSelected.AR_Code + " " + dataSelected.AR_Name);
      } else if (formData.APAR_Type === 'CP') {
        aparId = dataSelected.Comp_Id;
        setSelectName(dataSelected.Comp_Name_TH);
      }

      setFormData({
        ...formData,
        APAR_Id: aparId
      });
      setInitialFormData({
        ...initialFormData,
        APAR_Id: aparId
      });
      handleClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  return (
    <>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/tbsetbank" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลธนาคาร</h5>
            <div className="row g-3">

              <div className="col-4">
                <label>
                  เลขที่บัญชี <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="Bank_Account"
                  value={formData.Bank_Account || ""}
                  onChange={handleChange}
                  onKeyPress={(e) => {
                    const allowed = /[0-9-]/;
                    if (!allowed.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={13}
                />
              </div>

              <div className="col-4">
                <label>ชื่อบัญชี (ไทย)</label>
                <input type="text" className="form-control" name="Bank_Name_TH" value={formData.Bank_Name_TH || ""} onChange={handleChange} />
              </div>

              <div className="col-4">
                <label>ชื่อบัญชี (อังกฤษ)</label>
                <input type="text" className="form-control" name="Bank_Name_EN" value={formData.Bank_Name_EN || ""} onChange={handleChange} />
              </div>

              <div className="col-4">
                <label>ประเภทบัญชี</label>
                <select className="form-select" name="Bank_Type" value={formData.Bank_Type || ""} onChange={handleChange}>
                  <option value="SA">ออมทรัพย์</option>
                  <option value="CA">กระแสรายวัน</option>
                </select>
              </div>

              <div className="col-4">
                <label>กลุ่มผู้ใช้</label>
                <select className="form-select" name="APAR_Type" value={formData.APAR_Type || ""} onChange={handleChange}>
                  <option value="AP">เจ้าหนี้</option>
                  <option value="AR">ลูกหนี้</option>
                  <option value="CP">บัญชีของบริษัท</option>
                </select>
              </div>

              <div className="col-4">
                <label>เจ้าของบัญชี</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="apCode"
                    value={
                      (selectName || "")
                    }
                    disabled={true}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleShow}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>

                {formData.APAR_Type === "AP" && (
                  <ApModal
                    showApModal={showModal}
                    handleApClose={handleClose}
                    apDataList={apDataList}
                    onRowSelectAp={onRowSelect}
                  />
                )}

                {formData.APAR_Type === "AR" && (
                  <ArModal
                    showArModal={showModal}
                    handleArClose={handleClose}
                    arDataList={arDataList}
                    onRowSelectAr={onRowSelect}
                  />
                )}

                {formData.APAR_Type === "CP" && (
                  <CompModal
                    showCompModal={showModal}
                    handleCompClose={handleClose}
                    compDataList={compDataList}
                    onRowSelectComp={onRowSelect}
                  />
                )}
              </div>

              <div className="col-4">
                <label>
                  ธนาคาร <span style={{ color: "red" }}>*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="bankName"
                    value={selectBankName || ""}
                    disabled={true}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleShowBank}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>

                {showBankModal && (
                  <BankModal
                    showBankModal={showBankModal}
                    handleBankClose={handleCloseBank}
                    bankDataList={bankDataList}
                    onRowSelectBank={onRowSelectBank}
                  />
                )}
              </div>

              <div className="col-4">
                <label>สถานะ</label>
                <select className="form-select" name="Bank_Status" value={formData.Bank_Status || "Y"} onChange={handleChange}>
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>

              <div className="row mt-4">
                {mode !== "I" ? (
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <button
                        onClick={() => (window.location.href = "/tbsetbank")}
                        type="button"
                        className="btn btn-dark btn-lg me-2"
                      >
                        กลับค้นหา
                      </button>
                      <button
                        onClick={handleReset}
                        type="button"
                        className="btn btn-info btn-lg me-2"
                      >
                        เริ่มใหม่
                      </button>
                      <button
                        onClick={handleDelete}
                        type="button"
                        className="btn btn-danger btn-lg"
                      >
                        ลบ
                      </button>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleConfirmUpdate}
                        type="button"
                        className="btn btn-warning text-white btn-lg"
                      >
                        บันทึก
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="d-flex gap-2">
                      <button onClick={handleReset} type="button" className="btn btn-info btn-lg" style={{ width: "15%" }}>เริ่มใหม่</button>
                      <FormAction onSubmit={handleSubmit} onUpdate={handleSubmit} onDelete={handleDelete} mode={mode} />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Form;
